module.exports = __webpack_public_path__ + "img/laddercontrol3.e314f79f.png";